import RefreshIcon from "@mui/icons-material/Refresh";
import { Avatar, Box, Grid, Link, Tooltip, Typography } from "@mui/material";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getallOperationLogs } from "../../slices/Reports/DeviceCMDandOperationLogsSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import FilterOperationLOg from "./FilterOperationLog";

export default function OperationLogs() {
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    userName: "",
    module: "",
    subModule: "",
    operationType: "",
    operationDetails: "",
    opResult: "",
  });

  const defaultPaging = {
    page: 1,
    rowsPerPage: 10,
  };

  const defaultFilter = {
    userName: "",
    module: "",
    subModule: "",
    operationType: "",
    operationDetails: "",
    opResult: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
    setRowsPerPage(size);
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getallOperationLogs(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.OperationLog);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      userName: data.userName,
      module: data.module,
      subModule: data.subModule,
      operationType: data.operationType,
      operationDetails: data.operationDetails,
      opResult: data.opResult,
    });
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "open":
        return { color: "#0073e6", backgroundColor: "#e6f4ff" };
      case "closed":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      case "collected":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      default:
        return null;
    }
  };

  const StatusTab = ({ status }) => {
    const styles = getStatusStyles(status);
    if (!styles) {
      return null;
    }
    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <Grid style={{ flex: "0 0 75px" }}>
          <Typography style={{ ...styles, padding: "4px" }}>
            {status === "open"
              ? "Open"
              : status === "closed"
              ? "Closed"
              : status === "collected"
              ? "Collected"
              : ""}
          </Typography>
        </Grid>
      </Box>
    );
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const renderCell = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.created_at)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : "YYYY-MM-DD HH:mm"
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };
  const handleTextOverflowOperationDetails = (text) => {
    if (text && text.length > 30) {
      return text.substring(0, 30) + "...";
    } else {
      return text;
    }
  };

  const ZoomHandaler = (params) => (
    <SimpleDialogDemo
      button={
        <Avatar
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
      child={
        <Avatar
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #FFFF",
            fontSize: "100px",
            borderRadius: "50%",
          }}
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
    />
  );

  const columns = React.useMemo(
    () => [
      {
        field: " ",
        headerName: " ",
        sortable: false,
        width: 10,
        minWidth: 10,
      },
      {
        field: "UserName",
        headerName: t("Operator"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.userName,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.userName}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row?.userName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "created_at",
        headerName: t("Time Stamp"),
        flex: 1,
        minWidth: 140,
        renderCell:
          decoded_jwtToken.companyType !== "CUSTOMER"
            ? renderCell(formatDate(companySettings?.adminAndDealerDateFormat))
            : renderCell(formatDate(companySettings?.dateFormat)),
      },
      {
        field: "ipaddress",
        headerName: t("IP Address"),
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => params.row.ipaddress,
      },
      {
        field: "module",
        headerName: t("Module"),
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => params.row.module,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.module}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row?.module)}</span>
          </Tooltip>
        ),
      },
      {
        field: "subModule",
        headerName: t("Sub Module"),
        flex: 1,
        minWidth: 180,
        valueGetter: (params) => params.row.subModule,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.subModule}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row?.subModule)}</span>
          </Tooltip>
        ),
      },
      {
        field: "operationType",
        headerName: "Operation",
        flex: 1,
        minWidth: 160,
        valueGetter: (params) => params.row.operationType,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.operationType}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row?.operationType)}</span>
          </Tooltip>
        ),
      },
      {
        field: "content",
        headerName: "Operation Details",
        flex: 1,
        width: 20,
        minWidth: 240,
        valueGetter: (params) => {
          const content = params.row?.content;
          const remark = params.row?.remark;
          const decodedContent = content ? decodeURIComponent(content) : "";
          const decodedRemark = remark ? decodeURIComponent(remark) : "";
          const result = params.row.result;
          return decodedContent && decodedRemark
            ? `${
                decodedContent && decodedContent != "" ? decodedContent : ""
              } ${result === 0 ? "" : ", "} ${
                result === 0 ? "" : decodedRemark
              }`
            : decodedContent || decodedRemark || "----";
        },
        renderCell: (params) => {
          const content = params.row?.content;
          const remark = params.row?.remark;
          const result = params.row.result;
          const decodedContent = content ? decodeURIComponent(content) : "";
          const decodedRemark = remark ? decodeURIComponent(remark) : "";
          const displayText =
            decodedContent && decodedRemark
              ? `${
                  decodedContent && decodedContent != "" ? decodedContent : ""
                } ${result === 0 ? "" : ", "} ${
                  result === 0 ? "" : decodedRemark
                }`
              : decodedContent || decodedRemark || "----";
          return (
            <Tooltip
              title={
                <div
                  style={{
                    whiteSpace: "normal",
                    maxWidth: "210px",
                    wordWrap: "break-word",
                  }}
                >
                  {displayText}
                </div>
              }
              placement="bottom-start"
              // arrow
            >
              <span>{handleTextOverflowOperationDetails(displayText)}</span>
            </Tooltip>
          );
        },
      },
      {
        field: "result",
        headerName: "Result",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
          return (
            <div>
              {params.row.result === 0 ? (
                <b style={{ color: "green" }}>Success</b>
              ) : (
                <b style={{ color: "red" }}>Failure</b>
              )}
            </div>
          );
        },
      },
      {
        field: "costTime",
        headerName: "Time (ms)",
        flex: 1,
        // minWidth: 10,
        minWidth: 100,
        valueGetter: (params) => params.row.costTime,
      },
    ],
    []
  );

  return (
    <>
      <HeaderToolbar title={t("Operation Logs")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          <FilterOperationLOg
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
            date={formatDate(companySettings?.dateFormat)}
          />
        </Box>
        <Box>
          <Tooltip title={t("COMMON002")}>
            <Box item className="refreshIcon">
              <RefreshIcon onClick={() => loadData(filter, paging)} />
            </Box>
          </Tooltip>
        </Box>
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </>
  );
}
